function querySelectorAll<E extends Element = Element>(selector: string): NodeListOf<E> {
  return document.querySelectorAll(selector)
}

export default querySelectorAll
